export const WHO_YOU_ARE_OPTIONS = [
  {
    label: 'AdminHTML.Installation.Demographic.select1_option1_Label',
    value: 'Developer'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select1_option2_Label',
    value: 'Shop owner'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select1_option3_Label',
    value: 'Agency'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select1_option4_Label',
    value: 'Other',
  }
];

export const INDUSTRY_OPTIONS = [
  {
    label: 'AdminHTML.Installation.Demographic.select2_option1_Label',
    value: 'Beauty'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option2_Label',
    value: 'Clothing'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option3_Label',
    value: 'Electronics'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option4_Label',
    value: 'Furniture'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option5_Label',
    value: 'Handcrafts'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option6_Label',
    value: 'Jewelry'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option7_Label',
    value: 'Painting'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option8_Label',
    value: 'Photography'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option9_Label',
    value: 'Restaurants'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option10_Label',
    value: 'Groceries'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option11_Label',
    value: 'Other food & drink'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option12_Label',
    value: 'Sports'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option13_Label',
    value: 'Toys'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option14_Label',
    value: 'Services'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option15_Label',
    value: 'Virtual services'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option16_Label',
    value: 'Other'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select2_option17_Label',
    value: `I haven't decided yet`
  }
];

export const SOURCE_FROM_OPTIONS = [
  {
    label: 'AdminHTML.Installation.Demographic.select3_option1_Label',
    value: 'Shopify App Store'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select3_option2_Label',
    value: 'Google Ads'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select3_option3_Label',
    value: 'Search on Google, Bing, Yandex, etc'
  },
  {
    label: 'AdminHTML.Installation.Demographic.select3_option4_Label',
    value: 'Social Media',
  },
  {
    label: 'AdminHTML.Installation.Demographic.select3_option5_Label',
    value: 'Other' // please don't change value it.
  }
];